import { render, staticRenderFns } from "./NanHaiXiaoChengXu.vue?vue&type=template&id=237d92f8&"
import script from "./NanHaiXiaoChengXu.vue?vue&type=script&lang=js&"
export * from "./NanHaiXiaoChengXu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports